// client/src/utils/productSpecs.js
// Shared wording and helpers for a product's hobby details.
export const BUILD_TYPE_LABELS = {
  RTF: 'Ready-to-Fly (RTF)',
  BNF: 'Bind-and-Fly (BNF)',
  PNP: 'Plug-and-Play (PNP)',
  ARF: 'Almost-Ready-to-Fly (ARF)',
  KIT: 'Kit (build it yourself)',
};
export const BUILD_TYPE_HELP = {
  RTF: 'Usually comes with everything needed, including the radio.',
  BNF: 'Needs your own compatible transmitter.',
  PNP: 'Needs your own transmitter and receiver, and usually a battery.',
  ARF: 'Needs some assembly and its own electronics.',
  KIT: 'You build it yourself from parts.',
};
export const POWER_TYPES = ['Electric', 'Nitro', 'Petrol', 'Unpowered'];
export const CONDITIONS = ['Like new', 'Excellent', 'Good', 'Fair', 'For parts'];

export const splitList = (value) => (value ? String(value).split(/,\s*/).map((item) => item.trim()).filter(Boolean) : []);

// Every spec that has a value, ready to list on a product page.
export const specRows = (product) => [
  ['Type', BUILD_TYPE_LABELS[product.build_type]],
  ['Power', product.power_type],
  ['Scale', product.scale],
  ['Wingspan', product.wingspan_mm ? `${(product.wingspan_mm / 1000).toFixed(2)} m (${product.wingspan_mm} mm)` : null],
  ['Battery cells', product.battery_cells ? `${product.battery_cells}S` : null],
  ['Battery capacity', product.battery_mah ? `${product.battery_mah} mAh` : null],
  ['Radio channels', product.channels],
].filter(([, value]) => value);

export const youtubeEmbedUrl = (url) => {
  const match = String(url || '').match(/(?:v=|youtu\.be\/|shorts\/)([\w-]{6,20})/);
  return match ? `https://www.youtube-nocookie.com/embed/${match[1]}` : null;
};

// Models a shopper owns, kept on this device.
const MY_MODELS_KEY = 'myModels';
export const getMyModels = () => {
  try {
    const stored = JSON.parse(localStorage.getItem(MY_MODELS_KEY) || '[]');
    return Array.isArray(stored) ? stored : [];
  } catch (err) {
    return [];
  }
};
export const saveMyModels = (models) => {
  try {
    localStorage.setItem(MY_MODELS_KEY, JSON.stringify(models));
  } catch (err) {
    // Private browsing can refuse storage; the page still works for this visit.
  }
};
